// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"31":"1f7481fefa53fb3d","280":"d202cd2e3c28b98e","384":"b134386c96761d63"}[chunkId] + ".js";
};